/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListItem } from '../../models/list-item';

export interface GetClientFormOptions$Params {

/**
 * The ID of the client.
 */
  clientID: number;
      body?: {
'systemSettingTypeID'?: number;
'prefixText'?: string;
'count'?: number;
'customSource'?: string;
}
}

export function GetClientFormOptions(http: HttpClient, rootUrl: string, params: GetClientFormOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListItem>>> {
  const rb = new RequestBuilder(rootUrl, GetClientFormOptions.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ListItem>>;
    })
  );
}

GetClientFormOptions.PATH = '/api/Clients/GetClientFormOptions/{clientID}';
